export const scheduleExportTranslationsEn = {
  advancedSettings: {
    customPDFHeadline: 'Custom PDF headline',
    groupSequences: 'Group sequences',
    groupSequencesTooltip:
      'If activated all activities of project sequences will be grouped into summary tasks in the export.',
    hideDependencies: 'Hide dependencies',
    hideWeekends: 'Hide weekends',
    hideWeekendsDisabledWarning: 'Weekends can only be hidden for shorter time periods',
    showScheduleAlerts: 'Show collisions',
    showTodayLine: 'Show today line',
    hideEventsRow: 'Hide events row',
    title: 'Advanced settings',
  },
  asATableTitle: 'As a table',
  asGanttTitle: 'As Gantt',
  asInKopplaTitle: 'As in koppla',
  exportAsMPP: 'export as .mpp',
  exportAsXML: 'export as .xml',
  exportTitle: 'Export',
  format: {
    multiPage: 'Print on multiple pages',
    multiPageTooltip: 'The preview only shows a limited amount of pages.',
    orientation: {
      landscape: 'Landscape',
      portrait: 'Portrait',
    },
    plotter: 'Plotter',
    printer: 'Printer (for DIN Formats)',
    screenOptimized: 'Screen optimized',
    title: 'Format',
  },
  supportAlert: {
    excel: 'What’s special about Excel?',
    gantt: 'What’s special about Gantt?',
    pdf: 'What’s special about PDF?',
  },
  pdf: {
    error: 'Server error',
    exportedWith: 'Exported with',
    generating: 'PDF is generated...',
    headerInfo: {
      pages: 'Page {0} of {1}',
      pagesPlaceholder: '%PAGES%',
      plain: 'Version from {0}',
      withPages: 'Version from {0} - {1}',
      withPagesPlaceholder: 'Version from {0} - %PAGES%',
    },
    waiting: 'Download PDF',
  },
  settingsTitle: 'Settings',
  timePeriod: {
    title: 'Time period',
    placeholder: 'Whole Project',
  },
  types: {
    excel: 'Excel',
    msproject: 'MS Project',
    pdf: 'PDF',
    powerproject: 'Powerproject',
    primaverap6: 'Oracle Primavera P6',
  },
  export: {
    doneTitle: 'Export done!',
    failedButtonText: 'Adjust export settings',
    failedFirstLineText:
      'You can try to reduce the amount of data, by e.g. decreasing the exported time period.',
    failedSecondLineText: 'Contact our support, if the the problem persists.',
    failedTitle: 'Export failed',
    inProgressText: 'Your file will download automatically.',
    inProgressTitle: 'Export in progress',
    title: 'Export schedule',
  },
};
